import { Outlet } from 'react-router';
import AppProviders from './AppProviders';

export function Root() {
  return (
    <AppProviders>
      <Outlet />
    </AppProviders>
  );
}
